(function() {
  const originalFetch = window.fetch;
  window.fetch = function(...args) {
    return originalFetch.apply(this, args).then(response => {
      if (args[0] && (args[0].includes('/cart/add') || args[0].includes('/cart/change'))) {
        checkCartLimits();
      }
      return response;
    });
  };
})();

async function checkCartLimits() {
  const cart = await fetch('/cart.js').then(res => res.json());
  
  for (let i = 0; i < cart.items.length; i++) {
    const item = cart.items[i];
    
    // Fetch product data using the handle
    const product = await fetch(`/products/${item.handle}.js`).then(res => res.json());
    
    if (product.tags.includes('limit-one') && item.quantity > 1) {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: i + 1, quantity: 1 })
      });
      window.refreshCart();
      return;
    }
  }
}